var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ElementsSizeProvider", {
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ setSize, getBlockMinHeight }) {
          return [
            _c("div", { staticClass: "flex flex-col gap-4 h-full" }, [
              _c("div", [
                _c(
                  "span",
                  {
                    staticClass:
                      "flex font-400 labelWidth leading-6 text-lg text-primary-black",
                  },
                  [
                    _vm._v(" Active Clients "),
                    _vm.activeProjects && _vm.activeProjects.length > 0
                      ? _c(
                          "span",
                          { staticClass: "text-gray-new text-base ml-0.5" },
                          [
                            _vm._v(
                              "(" + _vm._s(_vm.activeProjects.length) + ")"
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm.activeProjects.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "CardsContainerManager",
                        _vm._l(_vm.activeProjects, function (project, index) {
                          return _c("ProjectCard", {
                            key: project.id,
                            attrs: {
                              project: project,
                              companyId: _vm.companyId,
                              currentUser: _vm.currentUser,
                              hideManager: _vm.hideManager,
                              descriptionBlockHeight: getBlockMinHeight({
                                id: project.id,
                                blockName: "description",
                                index,
                              }),
                            },
                            on: {
                              "update:descriptionBlockHeight": (minHeight) =>
                                setSize({
                                  id: project.id,
                                  blockName: "description",
                                  minHeight,
                                  index,
                                }),
                              projectUpdated: function ($event) {
                                return _vm.$emit("projectUpdated")
                              },
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", [
                    _c(
                      "p",
                      { staticClass: "font-normal text-base text-gray-new" },
                      [_vm._v(" No active projects. ")]
                    ),
                  ]),
            ]),
            _c("div", { staticClass: "flex flex-col gap-4 pb-6 mb-4" }, [
              _c("div", [
                _c(
                  "span",
                  {
                    staticClass:
                      "flex font-400 labelWidth text-lg leading-6 mt-2 text-primary-black",
                  },
                  [
                    _vm._v(" Closed Clients "),
                    _vm.completedProjects && _vm.completedProjects.length > 0
                      ? _c(
                          "span",
                          { staticClass: "text-gray-new text-base ml-0.5" },
                          [
                            _vm._v(
                              "(" + _vm._s(_vm.completedProjects.length) + ")"
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm.completedProjects.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "CardsContainerManager",
                        _vm._l(
                          _vm.completedProjects,
                          function (project, index) {
                            return _c("ProjectCard", {
                              key: project.id,
                              attrs: {
                                project: project,
                                companyId: _vm.companyId,
                                currentUser: _vm.currentUser,
                                hideManager: _vm.hideManager,
                                descriptionBlockHeight: getBlockMinHeight({
                                  id: project.id,
                                  blockName: "description",
                                  index,
                                }),
                              },
                              on: {
                                "update:descriptionBlockHeight": (minHeight) =>
                                  setSize({
                                    id: project.id,
                                    blockName: "description",
                                    minHeight,
                                    index,
                                  }),
                                projectUpdated: function ($event) {
                                  return _vm.$emit("projectUpdated")
                                },
                              },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", [
                    _c(
                      "p",
                      { staticClass: "font-normal text-base text-gray-new" },
                      [_vm._v(" No prevoius projects. ")]
                    ),
                  ]),
            ]),
            _c("div", { staticClass: "flex flex-col gap-4 pb-6 mb-4" }, [
              _c("div", [
                _c(
                  "span",
                  {
                    staticClass:
                      "flex font-400 labelWidth text-lg leading-6 mt-2 text-primary-black",
                  },
                  [
                    _vm._v(" Draft Clients "),
                    _vm.draftsProjects && _vm.draftsProjects.length > 0
                      ? _c(
                          "span",
                          { staticClass: "text-gray-new text-base ml-0.5" },
                          [
                            _vm._v(
                              "(" + _vm._s(_vm.draftsProjects.length) + ")"
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm.draftsProjects.length > 0
                ? _c(
                    "div",
                    [
                      _c(
                        "CardsContainerManager",
                        _vm._l(_vm.draftsProjects, function (project, index) {
                          return _c("ProjectCard", {
                            key: project.id,
                            attrs: {
                              project: project,
                              companyId: _vm.companyId,
                              currentUser: _vm.currentUser,
                              hideManager: _vm.hideManager,
                              descriptionBlockHeight: getBlockMinHeight({
                                id: project.id,
                                blockName: "description",
                                index,
                              }),
                            },
                            on: {
                              "update:descriptionBlockHeight": (minHeight) =>
                                setSize({
                                  id: project.id,
                                  blockName: "description",
                                  minHeight,
                                  index,
                                }),
                              projectUpdated: function ($event) {
                                return _vm.$emit("projectUpdated")
                              },
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _c("div", [
                    _c(
                      "p",
                      {
                        staticClass: "font-normal text-base text-gray-new mb-4",
                      },
                      [_vm._v(" No draft projects. ")]
                    ),
                  ]),
            ]),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }